/* unplugin-vue-components disabled */import { render } from "./order.vue?vue&type=template&id=0413c5b0&scoped=true"
const script = {}

import "./order.vue?vue&type=style&index=0&id=0413c5b0&lang=less&scoped=true"

import exportComponent from "/Users/yfy/work/work/cms-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0413c5b0"]])

export default __exports__